import { computed } from "vue";

export const useInvestorPlatform = () => {
  const config = useRuntimeConfig();

  const investorBaseUrl = computed(() => {
    const baseUrl = String(config.public.INVESTOR_BASE_URL);
    return baseUrl.replace(/\/$/, "");
  });

  const investorUrl = (path = "") => {
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    return `${investorBaseUrl.value}${normalizedPath}`;
  };

  return {
    investorBaseUrl,
    investorUrl,
  };
};
